export { default } from "./DeleteQueueModal";
